
import { ErrorCodes } from './errorCodes';
import { InformationCodes } from './informationCodes';

export interface LogErrorApiRequestModel {
    severityTypeId: number;
    code: ErrorCodes | InformationCodes;
    message: string;
    url: string;
    stackTrace?: string;
    lineNo?: string | number | null;
    columnNo?: string | number | null;
    userAgent: string;
    cookieEnabled: boolean;
    language: string;
    image: string | null;
    logId?: number | null;
}